import classnames from "classnames";

const Card = ({ item }) => {
  return (
    <div
      className={classnames(
        "rounded-xl",
        "backdrop-blur-lg border border-white/20 shadow-md",
        "transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg",
        "cursor-pointer flex flex-col justify-between w-full h-36 p-5",
        item.bgClass,
        item.textClass
      )}
      key={item?.id}
      aria-label={`Navigate to ${item.link}`}
    >
      <div className="flex justify-between items-start">
        <div className="flex flex-col gap-1">
          <h2 className="text-xl font-semibold">{item.number}</h2>
          <p className="text-sm opacity-80">{item.label}</p>
        </div>
        <div className="text-2xl">{item.icon}</div>
      </div>

      {/* Placeholder for a sparkline/mini-graph */}
      <div className="w-full h-5 mt-3 bg-white/20 rounded-md" />
    </div>
  );
};

export default Card;
